module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-tasks text-dark"
  }, [(_vm.isShowHeader) ? _c('div', {
    staticClass: "user-tasks__header no-print"
  }, [_c('div', {
    staticClass: "user-tasks__header__left"
  }, [_c('h2', {
    staticClass: "user-tasks__header__left__inner"
  }, [(!_vm.isCanSeeOtherUsers) ? _c('h2', [_vm._v(_vm._s(_vm.user.name))]) : _c('SelectUser', {
    attrs: {
      "preSelectedUserId": _vm.user_id,
      "userName": _vm.user_name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-mobile"
  }, [_vm._v("-")]), _vm._v(" "), (_vm.isKindergarten) ? _c('p', [_vm._v("Årsnormsoversigt")]) : _c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))])], 1), _vm._v(" "), (!_vm.initialStartDate) ? _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user-tasks__header__right"
  }, [(_vm.user && _vm.canUserSeeVersions) ? _c('TaskOverviewVersions', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isStartOrEndDateChanged) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
    attrs: {
      "startDate": _vm.activeSchoolYear.employee_time_start,
      "endDate": _vm.activeSchoolYear.employee_time_end,
      "selectedStartDate": _vm.startDate,
      "selectedEndDate": _vm.endDate
    },
    on: {
      "shortcutSelected": _vm.setDatesFromRange
    }
  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
    staticClass: "no-mobile marg-1-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && _vm.isShowHeader) ? _c('div', {
    staticClass: "d-box marg-1-bottom no-mobile"
  }, [_c('UserTasksChart', {
    attrs: {
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "calendarId": _vm.user.user_calendar_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoadingTasksForUser) ? _c('Loader') : _c('div', {
    staticClass: "marg-1-bottom"
  }, [_c('UserTasksOverview', {
    attrs: {
      "user": _vm.user,
      "dates": _vm.dates,
      "activeUserId": this.user.id,
      "isInUserCalendar": true,
      "isKindergarten": _vm.isKindergarten,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "isShowHeader": _vm.isShowHeader,
      "isPoolsDeactivated": _vm.isPoolsDeactivated,
      "schoolPrepFactor": _vm.schoolPrepFactor
    },
    on: {
      "changedIsShowScheduled": _vm.setIsShowScheduled
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43a9a536!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasks.vue
// module id = 1552
// module chunks = 1